import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {getWholeDivWrapperClass, LINK_CLASS,} from "../../sharedStyles.tsx";
import {defaultParserForSelects} from "../../../dyanimcFormUtil.tsx";


const StaticLinkDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value }) => {
    const parsedValue = defaultParserForSelects(value);
    value = parsedValue && parsedValue?.label ? parsedValue.label : value;
    return (
        <div className={getWholeDivWrapperClass(component)}>
            <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                className={LINK_CLASS}
                onClick={(e) => e.stopPropagation()}
            >
                {component.label}
            </a>
        </div>
    );
};

export const StaticLinkDisplay = React.memo(StaticLinkDisplayRenderer);